/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {convertToScript} from '../api'

export const useMutationConvertToScript = createReactQueryMutationHook('convertToScript', convertToScript)
